import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center border rounded-full px-2 pt-[3px] pb-1 text-xs font-medium focus:outline-none",
  {
    variants: {
      variant: {
        default: "border-primary/5 bg-primary/5 text-primary shadow",
        secondary: "border-secondary bg-secondary/50 text-white",
        destructive: "border-destructive/5 bg-destructive/5 text-destructive",
        success: "border-success/5 bg-success/5 text-success",
        info: "border-info/5 bg-info/5 text-info",
        outline: "text-foreground border-border",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
